import React from 'react';
import { Card, Col, Row, Tabs } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';

import PageTitle from '../../../components/page/PageTitle';
import ErrorBoundary from '../../../components/ErrorBoundary';
import ChargeCreditCardForm from '../../../components/billings/ChargeCreditCardForm';
import StoredCreditCardCard from './StoredCreditCardCard';
import BillingBalances from './BillingBalances';
import TransactionHistory from '../../../components/billings/TransactionHistory';
import { isModuleAvailable, MODULE_BILLING_CREDIT_CARD_PAYMENT } from '../../../lib/site';
import PromotionalCredits from '../../staff/promotions/PromotionalCredits';
import { useAppSelector } from '../../../hooks/useStore';

const Billing = () => {
    const [refreshBalances, setRefreshBalances] = React.useState(false);
    const [refetchStoredCard, setRefetchStoredCard] = React.useState(false);

    const roles = useAppSelector((state) => state.user.roles);
    const isOwner = roles?.user?.includes('owner') ?? false;

    const tabsItems = [
        {
            label: 'Balances',
            key: '1',
            children: (
                <ErrorBoundary>
                    <BillingBalances isOwner={isOwner} />
                    <TransactionHistory
                        refreshBalances={refreshBalances}
                        toggleRefreshBalances={setRefreshBalances}
                    />
                </ErrorBoundary>
            ),
        },
        {
            label: 'Promotional Credits',
            key: '3',
            children: (
                <ErrorBoundary>
                    <PromotionalCredits isOwner={isOwner} />
                </ErrorBoundary>
            ),
        },
        {
            label: 'Wallet',
            key: '4',
            children: (
                <ErrorBoundary>
                    <StoredCreditCardCard setRefetchStoredCard={setRefetchStoredCard} />
                </ErrorBoundary>
            ),
        },
    ];

    const PaymentsJSX = {
        label: 'Payments',
        key: '2',
        children: (
            <ErrorBoundary>
                <Row gutter={[{ xs: 0, md: 16 }, 16]}>
                    <Col xs={24} md={12} xl={8}>
                        <Card title="Credit Card Payment">
                            <ChargeCreditCardForm
                                toggleRefreshBalances={setRefreshBalances}
                                refetchStoredCard={refetchStoredCard}
                                setRefetchStoredCard={setRefetchStoredCard}
                            />
                        </Card>
                    </Col>
                </Row>
            </ErrorBoundary>
        ),
    };

    if (isModuleAvailable(MODULE_BILLING_CREDIT_CARD_PAYMENT)) {
        tabsItems.splice(1, 0, PaymentsJSX);
    }

    return (
        <>
            <PageTitle title="Billing" icon={<CreditCardOutlined />} />
            <Tabs defaultActiveKey="1" items={tabsItems} />
        </>
    );
};

export default Billing;
